import { INVALID_REQUEST_MADE } from './invalid-request-actions';

const initialState = null;

/**
 * Invalid Request Reducer
 *
 * Consumes INVALID_REQUEST_MADE action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {string} - the action type
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case INVALID_REQUEST_MADE:
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/app/errors/invalid-request-reducer.js